module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAAXNSR0IArs4c6QAAAMdJREFUKBWV0a8KAkEQx/HlwKLFKDbRKJgtoggWu2BRMAi+h9l+V0/svoBF0Ncw2QwaRBFdv3PIssf9deBztzM7Pzg4pf4orXUDTYk4eXMERuweMMibUYQWeEFqj1JmmKUJ3pC6YIO6CdIUTfM7MOvgDikXNbNDU4aHtRlyoK/ihBvG9l1wZtjGAx/0ZMjbwRZXdIPFuAeXQ8gnHeWe9xxP9OP2QzOWZpBa4oxpaCGtYdmH1CptL3JHoIUdsv+TnSZQQMWeJZ2/+ui/S4S+F6EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coo/icon_xuanzhong.png
// module id = xQGc
// module chunks = 2